import { eventsDuck } from '@eventbrite/redux-destination';
import * as analytics from '@eventbrite/site-analytics';
import {
    GA_CB_EVENT_CARD_CATEGORY,
    GA_SAVE_EVENT_ACTION,
    GA_SEARCH_CATEGORY,
    GA_UNSAVE_EVENT_ACTION,
} from '../../constants/analytics';

const {
    api: {
        saveEvent: saveEventApi,
        unsaveEvent: unsaveEventApi,
        loggedOutSaveRedirect,
    },
} = eventsDuck;

const { trackEventFromState } = analytics;

export const UPDATE_EVENT_SAVED_BY_YOU = 'updateEventSavedByYou';
export const updateEventSavedByYou = (
    eventId: number | string,
    savedByYou: boolean,
) => ({
    type: UPDATE_EVENT_SAVED_BY_YOU,
    payload: {
        eventId,
        savedByYou,
    },
});

const _loggedInSaveAction = (
    dispatch: Function,
    state: any,
    eventId: number,
    shouldSave: boolean,
    isSearch: boolean,
) => {
    const gaTrackingCategory = isSearch
        ? GA_SEARCH_CATEGORY
        : GA_CB_EVENT_CARD_CATEGORY;

    if (shouldSave) {
        //optimistic state set
        dispatch(updateEventSavedByYou(eventId, true));

        return saveEventApi(eventId)
            .then(() => {
                trackEventFromState(state, {
                    category: gaTrackingCategory,
                    action: GA_SAVE_EVENT_ACTION,
                    label: eventId,
                    dimensions: {
                        eventId,
                    },
                });

                //Resolved promise so view knows if the event save was successful
                return Promise.resolve('success');
            })
            .catch(() => dispatch(updateEventSavedByYou(eventId, false)));
    }
    //optimistic state set
    dispatch(updateEventSavedByYou(eventId, false));

    return unsaveEventApi(eventId)
        .then(() => {
            trackEventFromState(state, {
                category: gaTrackingCategory,
                action: GA_UNSAVE_EVENT_ACTION,
                label: eventId,
                dimensions: {
                    eventId,
                },
            });

            //Resolved promise so view knows that the event unsave was successful
            return Promise.resolve('success');
        })
        .catch(() => dispatch(updateEventSavedByYou(eventId, true)));
};

export const saveEvent =
    (
        eventId: number,
        shouldSave?: boolean,
        location?: object,
        isSearch?: boolean,
    ) =>
    (dispatch: Function, getState: () => any) => {
        const state = getState();
        const {
            auth: { isAuthenticated },
        } = state;

        if (isAuthenticated) {
            return _loggedInSaveAction(
                dispatch,
                state,
                eventId,
                shouldSave || false,
                isSearch || false,
            );
        }

        return loggedOutSaveRedirect(eventId, location);
    };
